import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {FoldersModelService} from '../../../Models/Rrhh/Folders/folders-model.service';

@Injectable({
  providedIn: 'root'
})
export class FoldersApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: FoldersModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las carpetas
   *
   */
  public getFolders(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getCarpetas').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los documentos de la carpeta
   *
   */
  public getFilesFolder(params: { id?: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getContenidoCarpeta', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Añadir documento
   *
   */
  public addFile(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setDocument', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar documento
   *
   */
  public deleteFile(params: { id?: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteDocument', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Ver información del documento
   *
   */
  public getFileInfo(params: { id?: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getVistasDocumento', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar información del documento
   *
   */
  public setFileInfo(params: { id: number, tiempo_visto: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setVistaDocumento', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
